import { Message } from '../models/message.model';

export enum RequestActionTypes {
    FETCH_REQUEST_START = 'FETCH_REQUEST_START',
    FETCH_REQUEST_SUCCESS = 'FETCH_REQUEST_SUCCESS',
    FETCH_REQUEST_FAILURE = 'FETCH_REQUEST_FAILURE',
};

export interface RequestState {
    message: Message | null;
    isFetching: boolean;
    requestErrorMessage: string | null;
};

export interface FetchRequestStartPayload {
    messageId: string;
    programmatic: boolean | undefined;
};

export interface FetchRequestSuccessPayload {
    message: object;
};

export interface FetchRequestFailurePayload {
    errorMessage: string;
};

export type FetchRequestStart = {
    type: typeof RequestActionTypes.FETCH_REQUEST_START;
    payload: FetchRequestStartPayload;
};

export type FetchRequestSuccess = {
    type: typeof RequestActionTypes.FETCH_REQUEST_SUCCESS;
    payload: FetchRequestSuccessPayload;
};

export type FetchRequestFailure = {
    type: typeof RequestActionTypes.FETCH_REQUEST_FAILURE;
    payload: FetchRequestFailurePayload;
};

export type RequestActions = 
    | FetchRequestStart
    | FetchRequestSuccess
    | FetchRequestFailure;